import { useHost } from '@admin-portal/host-contract';

export function Topbar({ onToggleSidebar }: { onToggleSidebar?: () => void }) {
  const { user, signOut } = useHost();
  return (
    <header className="topbar">
      {onToggleSidebar && (
        <button
          className="hamburger"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          {/* Inline SVG — no extra dep */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      )}
      <div className="spacer" />
      <div className="user">
        {user.pictureUrl && (
          <img
            src={user.pictureUrl}
            alt=""
            className="avatar"
            onError={(e) => (e.currentTarget.style.display = 'none')}
          />
        )}
        <span className="name">{user.displayName || user.lineUserId.slice(0, 8)}</span>
        <button onClick={signOut} className="sign-out">
          Sign out
        </button>
      </div>
    </header>
  );
}
